export default "__VITE_ASSET__DrrwzaLg__"